import React, { useEffect } from 'react';
import './FAQs.scss';
import { Link } from 'react-router-dom';
import { useAnalytics } from '../../customHooks/reactGA';

import Appbar from '../../components/Appbar/Appbar';
import Footer from '../../components/Footer/Footer';
import Form from '../../components/Form/Form';

import { Typography, Box } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

import iconLight from '../../assets/carp_house_plain.png';
import iconDark from '../../assets/carp-house-plain-dark.png';

const FAQs = (props) => {
  const { 
    trackPageView, 
    trackEvent 
  } = useAnalytics();

  useEffect(() => {
    trackPageView('/frequently-asked-questions');
  }, [trackPageView]);

  return (
    <div>
      <Appbar colorMode={props.colorMode} theme={props.theme} />
      <section
        className="landing"
        style={{
          backgroundColor:
            props.theme.palette.mode === "dark"
              ? props.theme.palette.primary.dark
              : '#e4e4e4',
          backgroundImage:
            props.theme.palette.mode === "dark"
              ? `url(${iconDark})`
              : `url(${iconLight})`
        }}
      >
        <div className="flex-container main-text-container">
          <div>
            <h1
              className="heading-title l1 heading-title--pop"
              style={{
                color:
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.warning.main
                    : props.theme.palette.primary.main,
              }}
            >
              Frequently Asked Questions
            </h1>
            <p
              className="heading-title l2"
              style={{
                color:
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark,
              }}
            >
              Explore our Frequently Asked Questions (FAQ's) to find answers to common inquiries about CarpHomes. If you can't find what you're looking for, reach out to our team for further assistance. We're here to ensure you have the information you need for a seamless experience with us.
            </p>
          </div>
        </div>
      </section>
      <div className='content-wrapper'>
        <Box padding={5}>
          <Box mt={20} mb={5}>
            {/* 1 */}
            <Accordion
              sx={{
                backgroundColor: props.theme.palette.mode === "dark"
                  ? props.theme.palette.primary.dark
                  : props.theme.palette.grey.A100
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
                <Typography fontFamily={'latoBold'} sx={{ color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.main }}>
                  Do I need to make repairs before selling my house?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.dark }}>
                  No. CarpHomes buys houses as-is, so you don’t need to make repairs, clean everything out, or spend money getting the property ready to sell. We’ll take a look at the home in its current condition and make our offer from there.
                </Typography>
              </AccordionDetails>
            </Accordion>

            {/* 2 */}
            <Accordion sx={{ backgroundColor: props.theme.palette.mode === "dark" ? props.theme.palette.primary.dark : props.theme.palette.grey.A100 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2-content" id="panel2-header">
                <Typography fontFamily={'latoBold'} sx={{ color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.main }}>
                  How quickly can CarpHomes buy my house?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.dark }}>
                  We can often close much faster than a traditional home sale. Every situation is different, so we’ll work with you to choose a closing date that makes sense for your timeline.
                </Typography>
              </AccordionDetails>
            </Accordion>

            {/* 3 */}
            <Accordion sx={{ backgroundColor: props.theme.palette.mode === "dark" ? props.theme.palette.primary.dark : props.theme.palette.grey.A100 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3-content" id="panel3-header">
                <Typography fontFamily={'latoBold'} sx={{ color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.main }}>
                  Are there any fees or commissions when I sell to CarpHomes?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.dark }}>
                  When CarpHomes buys your property directly, there are no real estate agent commissions. We’ll clearly explain the numbers and terms of our offer upfront so you know what to expect before making a decision.
                </Typography>
              </AccordionDetails>
            </Accordion>

            {/* 4 */}
            <Accordion sx={{ backgroundColor: props.theme.palette.mode === "dark" ? props.theme.palette.primary.dark : props.theme.palette.grey.A100 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4-content" id="panel4-header">
                <Typography fontFamily={'latoBold'} sx={{ color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.main }}>
                  What types of houses does CarpHomes buy?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.dark }}>
                  We buy homes in all kinds of situations and conditions—from well-maintained houses to properties that need significant repairs or updates. We also work with inherited properties, rentals, vacant homes, and houses that may be difficult to sell traditionally.
                </Typography>
              </AccordionDetails>
            </Accordion>

            {/* 5 */}
            <Accordion sx={{ backgroundColor: props.theme.palette.mode === "dark" ? props.theme.palette.primary.dark : props.theme.palette.grey.A100 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5-content" id="panel5-header">
                <Typography fontFamily={'latoBold'} sx={{ color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.main }}>
                  Am I obligated to sell after requesting an offer?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.dark }}>
                  No. Requesting an offer from CarpHomes does not obligate you to sell your house. We’ll evaluate the property, explain our offer, and give you the opportunity to decide whether selling to us makes sense for you.
                </Typography>
              </AccordionDetails>
            </Accordion>

            {/* 6 */}
            <Accordion sx={{ backgroundColor: props.theme.palette.mode === "dark" ? props.theme.palette.primary.dark : props.theme.palette.grey.A100 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel6-content" id="panel6-header">
                <Typography fontFamily={'latoBold'} sx={{ color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.main }}>
                  Will I get to meet someone from CarpHomes in person?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.dark }}>
                  Yes! We believe you should know exactly who you’re doing business with. A local CarpHomes team member will meet you in person and see your property firsthand before we purchase your home.
                  
                  We recommend being cautious of any company or investor willing to buy your house without ever seeing the property or meeting you in person. Selling a home is a major transaction, and you should feel confident that you’re working with a legitimate, local buyer who understands your property and will stand behind their offer.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Box>
        </Box>

        <section className="contact-form">
          <Box
            mt={15}
            mb={10}
          >
            <Typography
              sx={{
                color:
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.main,
                fontSize: "2rem",
                fontFamily: "karla",
                marginBottom: '0.5em',
                textAlign: 'center'
              }}
            >
              Get Your Free, No-Obligation Cash Offer Today
            </Typography>
            <Form theme={props.theme} />
          </Box>
          <Box
            mt={15}
            bgcolor={
              props.theme.palette.mode === "dark"
                ? props.theme.palette.primary.light
                : props.theme.palette.secondary.main
            }
            sx={{
              borderRadius: "25px 25px 0 0",
            }}
          >
            <Box className="contact-us-text-container">
              <Typography
                variant="h4"
                fontSize={'2.25rem'}
                fontFamily={"karla"}
                mb={2.5}
                mt={5}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.warning.main
                    : props.theme.palette.primary.dark
                }
              >
                Supplemental Services
              </Typography>
              <Typography
                lineHeight={2.5}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark
                }
              >
                In addition to our core focus of purchasing properties directly, our team offers supplemental services tailored to specific needs:
              </Typography>
              <Box>
                <ul>
                  <li>
                    <Typography
                      lineHeight={2.5}
                      color={
                        props.theme.palette.mode === "dark"
                          ? props.theme.palette.common.white
                          : props.theme.palette.primary.dark
                      }
                    >
                      <span>
                        <b>Realtor Services - </b>
                      </span>
                      If you're considering selling your home through the traditional market, our team can assist with listing your property and navigating the sales process. While our primary focus is on purchasing homes, this service is available for homeowners who prefer a traditional approach.
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      lineHeight={2.5}
                      color={
                        props.theme.palette.mode === "dark"
                          ? props.theme.palette.common.white
                          : props.theme.palette.primary.dark
                      }
                    >
                      <span>
                        <b>Construction Services for Investors - </b>
                      </span>
                      We provide expert construction management services exclusively for real estate investors. Whether you're a seasoned investor or new to the market, we can oversee renovation projects to maximize value and streamline the process. This service is ideal for out-of-state investors looking to expand their portfolio in the Indianapolis area without the hassle of managing projects locally.                </Typography>
                  </li>
                </ul>
              </Box>

              <Box mt={10}>
                <Typography
                  variant="h4"
                  fontSize={'2.25rem'}
                  fontFamily={"karla"}
                  color={
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.warning.main
                      : props.theme.palette.primary.main
                  }
                mb={2.5}
                // textAlign={'center'}
                >
                  Sell Your Indiana Home Fast with CarpHomes
                </Typography>
                <Typography
                  lineHeight={2.5}
                  mt={2}
                  color={
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.common.white
                      : props.theme.palette.primary.dark
                  }
                // textAlign={'center'}
                >
                  We make selling your home easy, fast, and stress-free. As a local Indiana business, we offer cash purchases with no realtor commissions or closing costs. Close in as little as 7 days—no repairs, no open houses, no hassle. Enjoy a private, personalized experience with a team that understands your needs every step of the way.
                </Typography>
              </Box>

              <Box display="flex" justifyContent="center" mt={5}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor:
                      props.theme.palette.mode === "dark"
                        ? props.theme.palette.warning.main
                        : props.theme.palette.primary.main,
                  }}
                  onClick={() => trackEvent('CTA', 'Click', 'Reach Out')}
                >
                  <Link className="link-item" to="/contact">
                    <Typography color={props.theme.palette.common.white}>
                      Reach Out
                    </Typography>
                  </Link>
                </Button>
              </Box>

            </Box>
          </Box>

        </section>

      </div>
      <Footer />
    </div>
  )
}

export default FAQs;
